"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoBasicMetadata = void 0;
var audio_stream_1 = require("./audio-stream");
var video_format_1 = require("./video-format");
var video_stream_1 = require("./video-stream");
var VideoBasicMetadata = /** @class */ (function () {
    function VideoBasicMetadata(data) {
        this.interlaced = null;
        this.videoStreams = [];
        this.audioStreams = [];
        this.format = null;
        this.interlaced = data.interlaced;
        this.videoStreams = data.videoStreams.map(function (videoStream) {
            return new video_stream_1.VideoStream(videoStream);
        });
        this.audioStreams = data.audioStreams.map(function (audioStream) {
            return new audio_stream_1.AudioStream(audioStream);
        });
        this.format =
            data.format === null
                ? data.format
                : new video_format_1.VideoFormat(data.format || undefined);
    }
    return VideoBasicMetadata;
}());
exports.VideoBasicMetadata = VideoBasicMetadata;
//# sourceMappingURL=video-basic-metadata.js.map